export const toNullableNumber = (value) => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const isValidNumber = (value) => value != null && !Number.isNaN(Number(value));